module.exports = __webpack_public_path__ + "static/media/certificate category.6e2a7b3d.svg";